import React from 'react';
import '../styles/main.scss';

interface ProgressBarProps {
  currentStep: number;
  steps: string[];
}

class ProgressBar extends React.Component<ProgressBarProps> {
  render() {
    const { currentStep, steps } = this.props;
    const totalSteps = steps.length;
    const progressPercentage = totalSteps > 1 
      ? ((Math.min(currentStep, totalSteps) - 1) / (totalSteps - 1)) * 100 
      : 0;

    return (
      <div className="progress-container">
        <div className="progress-line-background">
           <div className="progress-line-fill" style={{ width: `${progressPercentage}%` }} />
        </div>

        <div className="progress-steps">
          {steps.map((label, index) => {
            const stepNum = index + 1;
            const isActive = stepNum <= currentStep;
            const isCurrent = stepNum === currentStep;

            return (
              <div key={index} className="progress-step">
                <div className={`progress-circle ${isActive ? 'active' : ''} ${stepNum < currentStep ? 'completed' : ''}`}>
                  {stepNum < currentStep ? '✓' : stepNum}
                </div>
                <span className={`progress-label ${isCurrent ? 'current' : ''} ${isActive ? 'active' : ''}`}>
                  {label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ProgressBar;